module.exports = __webpack_public_path__ + "static/media/MovingApp_android_5.a694fd17.jpg";